module.exports = __webpack_public_path__ + "static/media/voltgroom-4.a3b453bd.jpg";